import React, { Fragment, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";

const RefugeAreaDetailView = ({ refugeAreas, isExpandable = true, t }) => {
  const fields = useMemo(
    () => [
      {
        name: "Floors",
        key: "floors",
        isRequired: false,
        renderField: (floors) =>
          floors.length ? floors.map(({ name }) => name).join(", ") : "N/A",
      },
      {
        name: "Area (Sq.Mtrs)",
        key: "area",
        isRequired: true,
      },
    ],
    []
  );

  return (
    <>
      <Collapse title="Refuge Area Details" isExpandable={isExpandable}>
        {refugeAreas.map((refugeArea, index) => (
          <Fragment key={refugeArea.id}>
            <Row className="d-flex  mb-2">
              <label className="fw-semibold">
                {t("Refuge Area") + " : " + (index + 1)}
              </label>
              {fields.map(({ name, key, isRequired, renderField }) => {
                const value = get(refugeArea, key, "");
                return (
                  <Col key={key} lg={6} className="mb-1">
                    <Row>
                      <Col md={5}>{t(name)}:</Col>
                      <Col
                        md={7}
                        className="fw-semibold"
                        style={{ wordBreak: "break-word" }}
                      >
                        {renderField
                          ? renderField(value)
                          : get(refugeArea, key, null) ??
                            (isRequired ? "-" : "N/A")}
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Fragment>
        ))}
      </Collapse>
    </>
  );
};

RefugeAreaDetailView.propTypes = {
  refugeAreas: PropTypes.object,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(RefugeAreaDetailView);
